import { Module } from "wrapper6";
import { toggleClass, hasClass, removeClass, addClass } from "../utils/_class-handlers";

var $ = jQuery;

export default class HoverEffect extends Module {

	ready(app) {

        // Nav
        // new Hover('#menu-main-menu', '#menu-main-menu > .menu-item > a');

        // Link wall
        const LINK_WALL_CONTAINERS = document.querySelectorAll('.link-wall-section__link-wrap');
        if (LINK_WALL_CONTAINERS.length) {
            for (let i = 0; i < LINK_WALL_CONTAINERS.length; i++) {
                const LINK_WALL_CONTAINER = LINK_WALL_CONTAINERS[i];
                new Hover(LINK_WALL_CONTAINER, '.link-wall-section-link', true);
            }
        }
        
    }
}

class Hover {

    constructor(container, cards, is_el = false) {

        // Set selectors
        this.CONTAINER_SELECTOR = container;
        this.CARDS_SELECTOR = cards;

        // Get container
        if (is_el) {
            this.CONTAINER = container;
        } else {
            this.CONTAINER = document.querySelector( this.CONTAINER_SELECTOR );
        }

        // Set active
        this.ACTIVE = null;
        this.BP = 1160;

        // The class to add and remove
        this.cls = 'inactive';

        // Check if container exists
        if (this.CONTAINER) {

            // Get cards 
            this.CARDS = this.CONTAINER.querySelectorAll( this.CARDS_SELECTOR );

            // Check if cards were found
            if (this.CARDS.length) {
                
                // Initialize the effect
                this.addEventListeners();

            }
        }
    }

    addEventListeners() {

        for (let i = 0; i < this.CARDS.length; i++) {

            const CARD = this.CARDS[i];

            // Set active card on mouseenter event
            CARD.addEventListener('mouseenter', () => {

                if (this.getScreenWidth() > this.BP) {

                    // Set active card
                    this.ACTIVE = CARD;
    
                    // Set active class
                    this.setActiveClass();

                }
            });

            CARD.addEventListener('mouseleave', () => {

                if (this.getScreenWidth() > this.BP) {

                    // Remove active class
                    this.addInactiveClass();
                    
                }
            });
        }

        // Reset classes when leaving container
        this.CONTAINER.addEventListener('mouseleave', () => {
            this.resetClasses();
        });
    }

    /**
     * Remove inactive class for hovered item
     */
    setActiveClass() {

        for (let i = 0; i < this.CARDS.length; i++) {
            this.CARDS[i].classList.add(this.cls);
        }

        this.ACTIVE.classList.remove(this.cls);
    }

    /**
     * Reset classes
     */
    resetClasses() {
        for (let i = 0; i < this.CARDS.length; i++) {
            this.CARDS[i].classList.remove(this.cls);
        }
    }

    /**
     * Add class for item left
     */
    addInactiveClass() {
        this.ACTIVE.classList.add(this.cls);
    }

    getScreenWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }   
}